import React, {FC} from "react";
import {useMarketItemContext} from "@constructor/components/features/market/items/context";
import {Text} from "@constructor/components";

const MarketItemLimit: FC = (props) => {
    const item = useMarketItemContext();
    if (!item) {
        return null;
    }

    return (
        <Text text={item.buyLimit} {...props} />
    )
}

export default MarketItemLimit;